import React, {Component} from 'react';
import {Button, Modal, Table, Popup} from 'semantic-ui-react';

import Loading from "../extras/Loading";
import {connect} from "react-redux";
import {openModalProductStock} from "../../actions/ModalProductStockActions";
import {listRecipeStock} from "../../actions/RecipeStockActions";
import {openModalProductStockUpdate} from "../../actions/ModalProductStockUpdateActions";
import RecipeStockData from "../../data/RecipeStockData";
import RecipeStockUpdate from "./RecipeStockUpdate";

class CurrentStockRecipeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            header: ['Sucursal', 'Porciones Disponibles', 'Acciones'],
            id: null,
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_stock_modal.id && this.state.id === null){
            RecipeStockData.listByRecipe(nextProps.product_stock_modal.id).then((data)=>{
                this.props.listRecipeStock(data);
                this.setState({loading:false, id:nextProps.product_stock_modal.id});
            });
        }
    }

    handleClose = () => {
        this.setState({loading:true, id:null});
        this.props.openModalProductStock({id:null, name:null, is_open:false});
    };

    updateDialog = (stock, is_add) => {
        this.props.openModalProductStockUpdate({
            is_open: true,
            is_add,
            product:{
                name: this.props.product_stock_modal.name,
                id: this.props.product_stock_modal.id,
            },
            stock,
        });
    };

    trackStockModal = (branch_office) => {
        this.props.openModalProductStockTrack({
            is_open: true,
            product: this.props.product_stock_modal.id,
            product_name: this.props.product_stock_modal.name,
            branch_office,
        });
    };

    render() {
        let rows = this.props.recipes_stock.map(stock => {
            return (
                <Table.Row
                    key={stock.id}
                    negative={stock.total <= 5 }
                    warning={stock.total > 5 && stock.total <= 10}
                >
                    <Table.Cell>{stock.name}</Table.Cell>
                    <Table.Cell>{stock.total}</Table.Cell>
                    <Table.Cell>
                        <Button.Group basic size='small'>
                            <Popup
                                trigger={<Button icon='plus' onClick={() => this.updateDialog(stock, true)}/>}
                                content='Agregar al Inventario'
                                size='small'
                            />
                            <Popup
                                trigger={<Button icon='remove' onClick={() => this.updateDialog(stock, false)}/>}
                                content='Quitar del Inventario'
                                size='small'
                            />
                        </Button.Group>
                    </Table.Cell>
                </Table.Row>
            )
        }, this);

        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.product_stock_modal.is_open} onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.product_stock_modal.name} - Inventario`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.loading ? <div style={{height:50}}><Loading/></div> : null}
                            {this.state.loading ? null :
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>{
                                            this.state.header.map(function (header, i) {
                                                return (
                                                    <Table.HeaderCell key={i}>
                                                        {header}
                                                    </Table.HeaderCell>
                                                )
                                            })
                                        }</Table.Row>
                                    </Table.Header>
                                    <Table.Body>{rows}</Table.Body>
                                </Table>
                            }
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <RecipeStockUpdate />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        product_stock_modal: state.get('product_stock_modal'),
        recipes_stock: state.get('recipes_stock'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalProductStock(modal){
            dispatch(openModalProductStock(modal))
        },
        listRecipeStock(products_stock){
            dispatch(listRecipeStock(products_stock))
        },
        openModalProductStockUpdate(modal){
            dispatch(openModalProductStockUpdate(modal))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CurrentStockRecipeModal);



// WEBPACK FOOTER //
// ./src/components/inventories/CurrentStockRecipeModal.js